if (!customElements.get("trustpilot-reviews")) {
  class TrustpilotReviews extends HTMLElement {
    #sectionHeight = 0;
    #resizeObserver;

    constructor() {
      super();
    }

    connectedCallback() {
      // Set up ResizeObserver to handle dynamic content (reviews injected by app)
      this.#resizeObserver = new ResizeObserver(this.#onResize);
      this.#resizeObserver.observe(this);

      // Also handle style attribute changes for theme editor sync
      this.mutationObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "attributes" && mutation.attributeName === "style") {
            this.#syncVars();
          }
        });
      });

      this.mutationObserver.observe(this, {
        attributes: true,
        attributeFilter: ["style"],
      });

      this.#onResize();
    }

    disconnectedCallback() {
      this.#resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
    }

    #onResize = () => {
      // Measure the intrinsic height of the component.
      this.#sectionHeight = this.scrollHeight;
      
      // Find the next section to determine how much scroll "track" we need for the parallax
      const nextSection = this.parentElement?.nextElementSibling;
      const nextSectionHeight = nextSection ? nextSection.offsetHeight : 0;

      // Update variables on the component
      this.style.setProperty("--section-height", `${this.#sectionHeight}px`);
      this.style.setProperty("--next-section-height", `${nextSectionHeight}px`);

      // Lift all variables to the parent
      this.#syncVars();
    };

    #syncVars = () => {
      const parent = this.parentElement;
      if (!parent) return;

      const styles = this.getAttribute("style");
      if (!styles) return;

      // Extract all CSS variables from the style attribute
      const varRegex = /(--[\w-]+)\s*:\s*([^;]+)/g;
      let match;

      while ((match = varRegex.exec(styles)) !== null) {
        const [_, prop, value] = match;
        parent.style.setProperty(prop, value.trim());
      }
    };
  }

  customElements.define("trustpilot-reviews", TrustpilotReviews);
}
